<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <rect width="64" height="64" fill="none"/>
    <g>
      <g>
        <circle class="filled" cx="26.053" cy="20.138" r="10.092" fill="#304266"/>
        <path class="filled" d="M26.053,34.879A19.08,19.08,0,0,0,7.226,50.87,2.687,2.687,0,0,0,9.9,53.954H42.208A2.687,2.687,0,0,0,44.88,50.87,19.08,19.08,0,0,0,26.053,34.879Z" fill="#304266"/>
      </g>
      <path class="filled" d="M55.576,27.143H50.428V22A1.233,1.233,0,0,0,49.2,20.763H47.964A1.232,1.232,0,0,0,46.732,22v5.148H41.583a1.233,1.233,0,0,0-1.232,1.232v1.232a1.232,1.232,0,0,0,1.232,1.232h5.149v5.149a1.232,1.232,0,0,0,1.232,1.232H49.2a1.233,1.233,0,0,0,1.232-1.232V30.839h5.148a1.232,1.232,0,0,0,1.233-1.232V28.375A1.233,1.233,0,0,0,55.576,27.143Z" fill="#304266"/>
    </g>
  </g>
</svg>
